import { AwardType, Bonus } from '../../../../types/bonus';
import anniversary from '../assets/images/award-anniversary.png';
import birthday from '../assets/images/award-birthday.png';
import claimable from '../assets/images/award-claimable.png';
import award from '../assets/images/award-manual.png';
import welcome from '../assets/images/award-welcome.png';
import wellness from '../assets/images/award-wellness.png';

export const useAwardIcon = (bonus: Bonus | null) => {
	if (!bonus) {
		return AwardType.Award;
	}
	const type = bonus.award_type || AwardType.Award;
	if ([AwardType.Award, AwardType.Claimable].includes(type)) return bonus.giver.profile_pic_url;
	else
		return (
			{
				award,
				birthday,
				claimable_award: claimable,
				custom_yearly_date: null,
				welcome,
				wellness,
				work_anniversary: anniversary,
				new_hire: null,
			}[type] ?? ''
		);
};
